import { Link } from 'react-router-dom';
import { formatDate, formatDday } from '@/lib/datetime';

interface ExamItemProps {
  studentId: string;
  studentName: string;
  title: string;
  startDate: string | null;
  endDate: string | null;
  scope: string;
  isPast: boolean;
}

const toneClass: Record<'past' | 'soon' | 'far', string> = {
  past: 'bg-background-200 text-foreground-500',
  soon: 'bg-accent-500 text-background-50',
  far: 'bg-primary-100 text-primary-700',
};

export default function ExamItem({
  studentId,
  studentName,
  title,
  startDate,
  endDate,
  scope,
  isPast,
}: ExamItemProps) {
  const dday = formatDday(endDate ?? startDate);

  return (
    <Link
      to={`/students/${studentId}`}
      className="flex flex-col gap-3 rounded-xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
    >
      <div className="flex items-start gap-3">
        <span
          className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${
            isPast ? 'bg-background-200 text-foreground-500' : 'bg-primary-100 text-primary-700'
          }`}
        >
          <i className="ri-file-list-3-line"></i>
        </span>
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2">
            <p className="text-sm font-semibold text-foreground-950">
              {studentName} · {title || '시험'}
            </p>
            {dday && (
              <span className={`rounded-full px-2.5 py-0.5 text-[11px] font-bold ${toneClass[dday.tone]}`}>
                {dday.label}
              </span>
            )}
          </div>
          <p className="mt-1 flex items-center gap-1 text-xs text-foreground-500">
            <i className="ri-calendar-line"></i>
            {formatDate(startDate)} ~ {formatDate(endDate)}
          </p>
          {scope && (
            <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">
              <span className="font-medium text-foreground-700">범위 </span>
              {scope}
            </p>
          )}
        </div>
      </div>
      <span className="flex items-center gap-1 self-end text-xs font-semibold text-primary-600 whitespace-nowrap">
        학생 카드 보기
        <i className="ri-arrow-right-line"></i>
      </span>
    </Link>
  );
}